/* -------------------------------------------------------------------------- */
/*                                 Schema Groups                              */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const group = new schema.Entity('groups', {}, { idAttribute: 'groupId' });
export const groups = new schema.Array(group);
